import React from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, withStyles, Button, Typography, IconButton, FormControl, TextField } from '@material-ui/core';
import { Add, Delete, Edit, FormatListBulleted } from '@material-ui/icons';
import PageTitle from '../../components/PageTitle/PageTitle';
import MUIDataTable from 'mui-datatables';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import Loader from '../../components/Loader/LoaderView';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import { clearLocalStorage } from '../../utils/common';
import CustomFooter from '../../components/Table/CustomFooter';

class AlertProfileManage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      checked: false,
      errorField: {
        name: false,
        manufacturer: false,
      },
      isLoading: false,
      labelWidth: 0,
      dialogOpen: false,
      profileId: null,
    };
  }
  async componentDidMount() {
    const { offset, limit, search, sort, order, action } = this.props.settingProfile.toJS();
    if (action) {
      await this.props.settingProfile.getSettingProfile(offset, limit, search, sort, order);
      this.props.settingProfile.setAction('action', null);
    } else {
      this.props.settingProfile.resetQueryParams();
      await this.props.settingProfile.getSettingProfile();
    }
    // await this.props.router.getRouters();
  }

  validateTableRow = (data, expectedSize) => {
    return data && Array.isArray(data) && data.length === expectedSize;
  };

  deleteItem(id) {
    const { t } = this.props;
    Swal.fire({
      html: `<span class="swal-icon">
                  <i
                    class="fa fa-trash-o fa-3x fa-border"
                    style="border: solid .08em #f27474; border-radius: 1.1em; margin-bottom: 35px; margin-top: 22px;">
                  </i>
                </span>
                <br/>
                <h3>${t('delete_profile')}</h3>`,
      showCancelButton: true,
      cancelButtonText: `${t('cancel')}`,
      confirmButtonText: `${t('delete')}`,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        try {
          const result = await this.props.settingProfile.settingProfileDelete(id);
          if (result.statusCode === 200) {
            Swal.fire({
              html: `<h4>${t('delete_success')}`,
              type: 'success',
            }).then(async (resultSuccess) => {
              if (resultSuccess.value) {
                await this.props.settingProfile.getSettingProfile();
              }
            });
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_delete')}`, type: 'error' });
          }
        } catch (e) {
          if (e.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_delete')}`, type: 'error' });
          }
        }
      }
    });
  }

  createProfile() {
    const { classes, t } = this.props;
    return (
      <Button
        id='create-patient'
        variant='outlined'
        color='primary'
        onClick={() => this.props.history.push('alertprofile/create')}
        className={classes.button}
      >
        <Add />
        {t('create_profile')}
      </Button>
    );
  }

  titleContent() {
    const { classes, t } = this.props;
    const { search } = this.props.settingProfile.toJS();
    return (
      <div className={classes.titleBar}>
        <Grid className={classes.search}>
          <FormControl variant='outlined' className={classes.formControl} fullWidth>
            <TextField
              variant='outlined'
              size='small'
              value={search || ''}
              name='search'
              id='search'
              className={classes.contentInput}
              placeholder={t('search')}
              onChange={(e) => this.handleChangeSearch(e)}
            ></TextField>
          </FormControl>
        </Grid>
      </div>
    );
  }

  handleChangeSearch = (event) => {
    const { value } = event.target;
    this.props.settingProfile.setData('offset', 0, false);
    this.props.settingProfile.setData('search', value);
  };

  handleChangeRowsPerPage = (value) => {
    this.props.settingProfile.setData('limit', value);
  };

  handlechangePage = (value) => {
    const { limit } = this.props.settingProfile.toJS();
    this.props.settingProfile.setData('offset', value * limit);
  };

  render() {
    const { classes, t } = this.props;
    const { settings, limit, search, sort, order } = this.props.settingProfile.toJS();
    const page = settings.data ? settings.pagination.page - 1 : 0;
    const count = settings.data ? settings.pagination.count : 0;

    const ARRAYSIZE = 4;
    const columns = [
      {
        name: 'id',
        label: `${t('id')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'id' && order ? order : 'none',
        },
      },
      {
        name: 'name',
        label: `${t('name')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'name' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return (
              <div>
                <Typography>{row[1]}</Typography>
              </div>
            );
          },
        },
      },
      {
        name: 'modifiedDate',
        label: `${t('modified_date')}`,
        options: {
          filter: false,
          sort: false,
          sortDirection: sort === 'modifiedDate' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return (
              <div>
                <Typography>{moment(row[2]).format('DD MMM YYYY hh:mm:ss A')}</Typography>
              </div>
            );
          },
        },
      },
      {
        name: '',
        label: '',
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return (
              <div className={classes.actionBox}>
                <Link
                  to={`/app/alertprofile/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/view`}
                  title={t('view')}
                >
                  {' '}
                  <IconButton>
                    <FormatListBulleted color='primary' />
                  </IconButton>
                </Link>
                <Link
                  to={`/app/alertprofile/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/edit`}
                  title={t('edit')}
                >
                  <IconButton>
                    {' '}
                    <Edit color='primary' />
                  </IconButton>
                </Link>
                <IconButton
                  title={t('delete')}
                  onClick={() => this.deleteItem(this.validateTableRow(row, ARRAYSIZE) ? row[0] : '')}
                >
                  <Delete color='primary' />
                </IconButton>
              </div>
            );
          },
        },
      },
    ];

    return (
      <React.Fragment>
        <Loader loading={this.state.isLoading} />
        <PageTitle title={t('alert_setting_profile')} button={this.createProfile()}>
          {this.titleContent()}
        </PageTitle>
        <Grid container spacing={32} className={classes.mainContain}>
          <Grid item xs={12}>
            <MUIDataTable
              data={settings.data || []}
              columns={columns}
              options={{
                count: settings.data ? settings.pagination.count : 0,
                page: settings.data ? settings.pagination.page - 1 : 0,
                searchText: search,
                serverSide: true,
                pagination: true,
                onTableChange: (action, tableState) => {
                  // console.log(action, tableState);
                  switch (action) {
                    case 'changePage':
                      this.props.settingProfile.setData('offset', tableState.page * tableState.rowsPerPage);
                      // this.props.user.setData('page',tableState.page);
                      break;
                    case 'changeRowsPerPage':
                      this.props.settingProfile.setData('limit', tableState.rowsPerPage);
                      break;
                    case 'search':
                      this.props.settingProfile.setData('offset', 0, false);
                      this.props.settingProfile.setData('search', tableState.searchText);
                      break;
                    case 'sort':
                      const sortList = tableState.announceText.split(' ');
                      this.props.settingProfile.setData('offset', 0, false);
                      this.props.settingProfile.setData('sort', sortList[4], false);
                      this.props.settingProfile.setData('order', sortList[6] === 'descending' ? 'desc' : 'asc');
                      break;
                    default:
                      break;
                  }
                },
                print: false,
                download: false,
                viewColumns: false,
                search: false,
                sortFilterList: true,
                sort: true,
                selectableRows: 'none',
                selectableRowsOnClick: false,
                filter: false,
                filterType: 'dropdown',
                responsive: 'scrollFullHeight',
                rowsPerPageOptions: [10, 15, 50],
                rowsPerPage: limit,
                customFooter: (rowsPerPage, changeRowsPerPage, changePage, textLabels) => {
                  return (
                    <CustomFooter
                      count={count}
                      page={page}
                      rowsPerPage={limit}
                      changeRowsPerPage={this.handleChangeRowsPerPage}
                      changePage={this.handlechangePage}
                      textLabels={textLabels}
                      rowsPerPageOptions={[10, 15, 50]}
                    />
                  );
                },
              }}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  paper: {
    padding: '50px',
    // marginTop: '-100px',
    height: '100%',
  },
  mainContain: {
    marginTop: '5px',
    padding: 16,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    height: '38px',
    margin: theme.spacing.unit / 2,
    marginTop: 11,
  },
  formInput: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    '& label': {
      transform: 'translate(0px, 7px) scale(0.7) !important',
      fontSize: '1.33rem !important',
    },
  },
  actionBox: {
    minWidth: '280px',
  },
  columnWidth200: {
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  textLabel: {
    color: 'rgb(0, 150, 135)',
    fontSize: '1.4rem',
  },
  formControl: {
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    margin: theme.spacing.unit / 2,
    width: '100%',
    marginLeft: theme.spacing.unit * 2,
  },
  contentInput: {
    '& fieldset': {
      top: '2px',
    },
    '& input': {
      paddingTop: '17px',
      paddingBottom: '9px',
    },
  },
  titleBar: {
    display: 'flex',
    marginTop: '-5px',
  },
  search: {
    width: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '250px',
    },
  },
});

export const page = inject('settingProfile', 'router')(observer(AlertProfileManage));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
